import PageContainer from '@/common/components/PageContainer'
import useQueryGetOperators from '@/modules/admin/api/hooks/useQueryGetOperators'
import OperatorListing from '@/modules/manage-operator/components/OperatorListing'
import { getOperatorTableColumns } from '@/modules/manage-operator/components/OperatorTable/constants'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

export default function ManageOperatorsPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		username: searchQuery,
	}

	const { data } = useQueryGetOperators(payload)

	const operatorList = data?.data || []
	const totalOperators = data?.total || 0
	const columns = getOperatorTableColumns()

	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<OperatorListing
					data={operatorList}
					total={totalOperators}
					columns={columns}
				/>
			</div>
		</PageContainer>
	)
}
